import { render, staticRenderFns } from "./WalletAccountingReport.vue?vue&type=template&id=965732c4"
import script from "./WalletAccountingReport.vue?vue&type=script&lang=js"
export * from "./WalletAccountingReport.vue?vue&type=script&lang=js"
import style0 from "./WalletAccountingReport.vue?vue&type=style&index=0&id=965732c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports